module.exports = __webpack_public_path__ + "static/media/eng_d_2511.ca400d65.mp4";